import { useContext, useState } from "react";
import PopupContext from "../../../context/context-popup";

import SidePopup from "../../../components/side-popup";
import List from "../../../components/list";
import InputsTextArea from "../../../components/inputs/inputs-text-area";
import { ButtonCancel, ButtonModify, ButtonRemove, ButtonSave } from "../../../components/buttons";
import meetingsApi from "../../../lib/meetings/meetings-api";
import InputsText from "../../../components/inputs/inputs-text";
import ContentDropdown from "../../../components/content-dropdown";
import LabelContainer from "../../../components/label-container";
import Container from "../../../layouts/containers/container";
import Row from "../../../components/row";
import InputsCheckbox from "../../../components/inputs/inputs-checkbox";

import { toast } from 'react-toastify';
import ErrorContainer from "../../../components/error-container";

import SidePopupSection from "../../../components/side-popup/section";
import { stringToFriendlyDatetime } from "../../../lib/helpers/datetime-helpers";
import Grid from "../../../components/grid";

export default function PopupsViewBillingProfile({ profile }) {
    const { closePopup } = useContext(PopupContext);
    const [ errors, setErrors ] = useState({});

    const [ params, setParams ] = useState({

    })
    
    return (
        <SidePopup title='Billing Profile'>
            <SidePopupSection title={
                <Row justifyContent="space-between">
                    <Container.Text fontSize="16px" color="#929BA8">Details</Container.Text>
                </Row>
            }>
                <Container>
                    <Grid columns={2} gap="40px">
                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Date Created</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ stringToFriendlyDatetime(profile?.created_at) }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Address One</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.address_one }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Address Two</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.address_two }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">City</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.city }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Country</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.country }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">County</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.county }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Email Address</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.email_address }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">First Name</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.first_name }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Last Name</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.last_name }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Postcode</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.postcode }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">SAP Number</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.sap_number }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">PO Number</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.po_number }</Container.Text>
                            </Container.Content>
                        </Container>

                        <Container style={{flex: '1 0 0'}}>
                            <Container.Header>
                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Title</Container.Title>
                            </Container.Header>
                            <Container.Content>
                                <Container.Text fontSize="16px">{ profile?.title }</Container.Text>
                            </Container.Content>
                        </Container>
                    </Grid>
                </Container>
            </SidePopupSection>
        </SidePopup>
    )
}